import React, { useEffect } from "react";
import { connect } from "react-redux";
import rmsActions from "../../../../actions/rmsActions";
import { getResources, getRmsAppCode, isFetching } from "../../../../reducers";
import { DataTypes } from "../../../../constants";
import ThisTheme from "../../../../themes/PORTTheme";
import BlankCard from "../../../Common/Card/BlankCard";
import ResourcesCard from "./ResourcesCard";
import PORTErrorCard from "../PORTErrorCard";

const MyResourcesCard = ({ resources, isFetching, getResources, appCode }) => {
    useEffect(() => {
        getResources(appCode);
    }, [getResources, appCode]);

    if (isFetching) return <BlankCard />;

    return resources ? (
        <ResourcesCard data={resources} theme={ThisTheme} />
    ) : (
        <PORTErrorCard
            resource="resource"
            title="Resources"
            error="No data available"
            message="An error occurred while trying to connect the portfolio service."
        />
    );
};

const mapStateToProps = (state) => ({
    resources: getResources(state),
    isFetching: isFetching(state, DataTypes.RESOURCES),
    appCode: getRmsAppCode(state),
});

export default connect(mapStateToProps, {
    getResources: rmsActions.getResources,
})(MyResourcesCard);
